<div class="navbar-container">
  <div class="container-nav1">
    <nav class="navbar1 navbar-expand-lg">
      <a class="navbar-brand" routerLink="/">
        @if ($currentUser() && $currentUser()?.company?.logo_file) {
          <img
            class="logo c-ml-20 c-mh-60"
            src="{{ displayImage($currentUser()?.company?.logo_file) }}"
            title="{{ $currentUser()?.company?.company_name }}"
          />
        }
      </a>

      <div class="navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav align-items-center">
          <li>
            <p-iconField iconPosition="right">
              <p-inputIcon styleClass="pi pi-search pr-2 text-lg" />
              <input
                #searchInput
                class="form-control"
                name="search_box"
                id="search_box"
                type="text"
                [formControl]="searchControl"
                placeholder="{{
                  $languageList()[selectedLanguage][
                    '_LBL_SEARCH_PLACEHOLDER'
                  ] ?? 'Search product'
                }}"
                style="font-size: 15px"
                aria-label="Search"
                autocomplete="off"
              />
            </p-iconField>
          </li>

          <li
            *ngIf="$currentUser()?.default_user"
            class="nav-item"
            routerLink="/resources/contact-us"
            style="cursor: pointer"
            title="Contact Us"
          >
            <i class="pi pi-envelope" style="font-size: 20px"></i>
          </li>
          <li
            *ngIf="$currentUser()?.default_user"
            class="nav-item"
            (click)="callSignIn()"
            style="cursor: pointer"
          >
            <i class="pi pi-user" style="font-size: 20px"></i>
          </li>
          <li *ngIf="!$currentUser()?.default_user" class="nav-item">
            <div class="collection">
              <a class="nav-link" routerLink="/collection">
                @if (!$myCollectionTotalCount()) {
                  <i class="pi pi-heart" style="font-size: 22px"></i>
                } @else {
                  <i class="pi pi-heart" style="font-size: 22px"></i>
                }
                <span style="margin-left: 7px; font-size: 15px">
                  {{
                    $languageList()[selectedLanguage]['_TXT_MY_COLLECTION'] ??
                      'My Collection'
                  }}
                </span>
              </a>

              <span
                class="nav-link"
                style="
                  margin-left: 3px;
                  font-size: 15px;
                  align-items: center;
                  display: flex;
                "
                >({{ $myCollectionTotalCount() }})</span
              >
            </div>
          </li>
          <li class="nav-item">
            <div class="shopping-cart">
              <ng-container *ngIf="$lastedOrder()?.['_id']; else noOrder">
                <a
                  class="nav-link"
                  [routerLink]="['/order/detail/edit', $lastedOrder()._id]"
                >
                  <i class="pi pi-shopping-cart" style="font-size: 22px"></i>

                  <span style="margin-left: 7px; font-size: 15px">
                    {{
                      $languageList()[selectedLanguage]['_TXT_CART'] ?? 'Cart'
                    }}
                  </span>

                  <span
                    style="margin-left: 3px; font-size: 15px"
                    class="shopping-badge nav-link"
                  >
                    @if (
                      $lastedOrder().order_item_list &&
                      $lastedOrder().order_item_list.length
                    ) {
                      ({{ $lastedOrder().order_item_list.length }})
                    } @else {
                      (0)
                    }
                  </span>
                </a>
              </ng-container>
              <ng-template #noOrder>
                <i class="pi pi-shopping-cart" style="font-size: 22px"></i>
                <span style="margin-left: 7px; font-size: 15px">Cart</span>
                <span
                  style="margin-left: 3px; font-size: 15px"
                  class="shopping-badge nav-link"
                >
                  @if (
                    $lastedOrder().order_item_list &&
                    $lastedOrder().order_item_list.length
                  ) {
                    ({{ $lastedOrder().order_item_list.length }})
                  } @else {
                    (0)
                  }
                </span>
              </ng-template>
            </div>
          </li>
          <li *ngIf="!$currentUser()?.default_user" class="nav-item">
            <div class="user-menu">
              <a class="nav-link cursor-pointer" (click)="logOut()">
                <i class="pi pi-sign-out" style="font-size: 16px"></i>
                <span style="margin-left: 7px; font-size: 15px">
                  {{
                    $languageList()[selectedLanguage]['_LOGOUT_'] ?? 'Logout'
                  }}
                </span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
  <div class="container-nav2">
    <nav class="navbar2">
      <ul class="topbar-menu">
        @for (item of $menusItems(); track $index; let i = $index) {
          <li class="menu-item py-1">
            @if (!item.folder_id) {
              <a
                class="topbar-menu-link"
                [routerLink]="['/categoryB2B', item.alias]"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                {{ displayTagName(item) }}
                <i
                  class="pi pi-angle-down"
                  style="font-size: 12px; margin-left: 4px; font-weight: bold"
                ></i>
              </a>
            } @else {
              <!-- [routerLink]="['/resources/folder/', item.folder_id]" -->
              <a
                class="topbar-menu-link"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                {{ displayTagName(item) }}
                <i
                  class="pi pi-angle-down"
                  style="font-size: 12px; margin-left: 4px; font-weight: bold"
                ></i>
              </a>
            }

            @if (item.childs.length > 12) {
              <ul
                class="submenu"
                style="grid-template-columns: repeat(4, 1fr); min-width: 800px"
              >
                @for (subItem of item.childs; track $index; let j = $index) {
                  <li class="submenu-item">
                    @if (!subItem.folder_id) {
                      <a
                        [routerLink]="[
                          '/categoryB2B',
                          item.alias + '--' + subItem.alias,
                        ]"
                        class="submenu-link"
                      >
                        {{ displayTagName(subItem) }}
                      </a>
                    } @else {
                      <a
                        [routerLink]="['/resources/folder/', subItem.folder_id]"
                        class="submenu-link"
                      >
                        {{ displayTagName(subItem) }}
                      </a>
                    }
                  </li>
                }
              </ul>
            } @else if (item.childs.length > 6) {
              <ul
                class="submenu"
                style="grid-template-columns: repeat(2, 1fr); min-width: 400px"
              >
                @for (subItem of item.childs; track $index; let j = $index) {
                  <li class="submenu-item">
                    @if (!subItem.folder_id) {
                      <a
                        [routerLink]="[
                          '/categoryB2B',
                          item.alias + '--' + subItem.alias,
                        ]"
                        class="submenu-link"
                      >
                        {{ displayTagName(subItem) }}
                      </a>
                    } @else {
                      <a
                        [routerLink]="['/resources/folder/', subItem.folder_id]"
                        class="submenu-link"
                      >
                        {{ displayTagName(subItem) }}
                      </a>
                    }
                  </li>
                }
              </ul>
            } @else {
              <ul class="submenu" style="min-width: 160px">
                @for (subItem of item.childs; track $index; let j = $index) {
                  <li class="submenu-item">
                    @if (!subItem.folder_id) {
                      <a
                        [routerLink]="[
                          '/categoryB2B',
                          item.alias + '--' + subItem.alias,
                        ]"
                        class="submenu-link"
                      >
                        {{ displayTagName(subItem) }}
                      </a>
                    } @else {
                      <a
                        [routerLink]="['/resources/folder/', subItem.folder_id]"
                        class="submenu-link flex justify-content-between align-items-center"
                      >
                        {{ displayTagName(subItem) }}
                        <i
                          class="pi pi-angle-right"
                          style="font-size: 13px; margin-left: 10px"
                        ></i>
                      </a>

                      @for (
                        folder of $folderList();
                        track $index;
                        let m = $index
                      ) {
                        @if (folder.key === subItem.no) {
                          <ul
                            class="submenu"
                            style="
                              margin-left: -5px;
                              margin-top: -1px;
                              grid-template-columns: repeat(2, 1fr);
                              min-width: 300px;
                            "
                          >
                            @for (
                              subFolder of folder.value;
                              track $index;
                              let n = $index
                            ) {
                              <li class="submenu-item">
                                <a
                                  class="submenu-link"
                                  [routerLink]="[
                                    '/resources/detail/',
                                    subFolder._id,
                                  ]"
                                >
                                  {{ subFolder.folder_name }}
                                </a>
                              </li>
                            }
                          </ul>
                        }
                      }
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
      <ul class="topbar-menu2">
        <li class="nav-item" *ngIf="!$currentUser()?.default_user">
          <div>
            <a class="no-underline" routerLink="/account-information">
              <span style="font-size: 15px"
                >{{
                  $languageList()[selectedLanguage]['_TXT_HELLO'] ?? 'Hello'
                }},
                {{
                  [
                    $currentUser()?.user_first_name ?? '',
                    $currentUser()?.user_last_name ?? '',
                  ].join(' ')
                }}!</span
              >
            </a>
          </div>
        </li>
        <li class="nav-item">
          <a class="no-underline">
            <span style="font-size: 15px"> Tools & Reports </span>
            <i
              class="pi pi-angle-down"
              style="font-size: 12px; margin-left: 4px; font-weight: bold"
            ></i>
          </a>

          <ul class="submenu2">
            <li class="submenu-item2">
              <a
                [routerLink]="['/resources/inventory-report']"
                class="submenu-link"
              >
                Inventory Report
              </a>
            </li>

            <li class="submenu-item2">
              <a
                [routerLink]="['/resources/order-report']"
                class="submenu-link"
              >
                Order Report
              </a>
            </li>

            <li class="submenu-item2">
              <a
                [routerLink]="['/resources/manage-profile']"
                class="submenu-link"
              >
                Manage Location Profile
              </a>
            </li>

            <li class="submenu-item2" [hidden]="!is_use_campaign">
              <a
                [routerLink]="['/resources/campaign-budget']"
                class="submenu-link"
              >
                Create Campaign Budget
              </a>
            </li>
            <!-- @if (!not_implement) { -->
            <li class="submenu-item2" [hidden]="!is_use_campaign">
              <a
                [routerLink]="['/resources/campaign-excel']"
                class="submenu-link"
              >
                Create Campaign (Excel)
              </a>
            </li>
            <!-- <li class="submenu-item2">
              <a
                [routerLink]="['/resources/distroListFE']"
                class="submenu-link"
              >
                Generate Distro List
              </a>
            </li> -->
            <!-- } -->
            @if (
              resourcePermission &&
              resourcePermission['access'] === 'enable' &&
              resourcePermission['view'] !== 'not_set' &&
              resourcePermission['view'] !== 'none'
            ) {
              <li class="submenu-item2">
                <a
                  [routerLink]="['/resources/media-management']"
                  class="submenu-link"
                >
                  Media management
                </a>
              </li>
            }

            <li class="submenu-item2" [hidden]="!tracking_program">
              <a
                [routerLink]="['/resources/shipment-tracking']"
                class="submenu-link"
              >
                Shipment Tracking
              </a>
            </li>

            <!-- } -->
          </ul>
        </li>
        <li *ngIf="!$currentUser()?.default_user" class="nav-item">
          <a
            style="font-size: 15px; text-transform: none"
            class="topbar-menu-link"
          >
            {{
              $languageList()[selectedLanguage]['_TXT_MY_ACCOUNT'] ??
                'My Account'
            }}

            <i
              class="pi pi-angle-down"
              style="font-size: 12px; margin-left: 4px; font-weight: bold"
            ></i>
          </a>
          <ul class="submenu2">
            <li class="submenu-item2">
              <a routerLink="/account-information" class="submenu-link">
                {{
                  $languageList()[selectedLanguage]['_TXT_ACCOUNT_INFO'] ??
                    'Account Information'
                }}
              </a>
            </li>
            <li class="submenu-item2">
              <a routerLink="/orders/list" class="submenu-link">
                {{
                  $languageList()[selectedLanguage]['_TXT_ORDER_STATUS'] ??
                    'Order Status'
                }}
              </a>
            </li>
            <li class="submenu-item2" [hidden]="!is_use_campaign">
              <a routerLink="/campaign/status" class="submenu-link">
                {{
                  $languageList()[selectedLanguage]['_TXT_CAMPAIGN_STATUS'] ??
                    'Campaign Status'
                }}
              </a>
            </li>
            <li class="submenu-item2">
              <a
                [routerLink]="['/resources/storeProfile']"
                class="submenu-link"
              >
                Signage Profile
              </a>
            </li>
            <li class="submenu-item2">
              <a [routerLink]="['/resources/contact-us']" class="submenu-link">
                Contact Us
              </a>
            </li>

            <!-- @if (

              resourcePermission &&
              resourcePermission['access'] === 'enable' &&
              resourcePermission['view'] !== 'not_set' &&
              resourcePermission['view'] !== 'none'
            ) {
              <li class="submenu-item2">
                <a
                  [routerLink]="['/resources/media-management']"
                  class="submenu-link"
                >
                  Media management
                </a>
              </li>

            } -->

            <!-- } -->
          </ul>
        </li>

        <li
          class="nav-item"
          *ngIf="
            user_language === 'bil' ||
            user_language === 'bef' ||
            user_language === 'bfe'
          "
        >
          <div>
            <p-dropdown
              [options]="languages"
              [(ngModel)]="selectedLanguage"
              optionLabel="name"
              optionValue="code"
              placeholder="Select Language"
              styleClass="border-1 border-600"
              [style]="{ width: '115px' }"
              (onChange)="setLanguage()"
            >
              <!-- Template for dropdown items -->
              <ng-template let-language pTemplate="item">
                <div class="flex align-items-center">
                  <i class="{{ language.icon }}" style="margin-right: 8px"></i>
                  {{ language.name }}
                </div>
              </ng-template>

              <!-- Template for selected item -->
              <ng-template let-language pTemplate="selectedItem">
                <div class="flex align-items-center">
                  <i class="{{ language?.icon }}" style="margin-right: 8px"></i>
                  <span style="font-weight: 600">{{ language?.name }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</div>
<div>
  <!-- Scroll To Top Button -->
  <button
    pButton
    class="scroll-top-btn"
    icon="pi pi-arrow-up"
    (click)="scrollToTop()"
    *ngIf="showScrollButton"
  ></button>
</div>
<app-topbar></app-topbar>

<div class="custom-dialog">
  <p-dialog
    header="Idle Warning"
    [draggable]="false"
    [modal]="true"
    [(visible)]="popupTimeoutLogin"
    styleClass="dialog-responsive mx-2 m-md-0 custom-dialog"
    [closable]="true"
    [style]="{ width: '500px' }"
    [closeOnEscape]="true"
  >
    <div class="d-flex flex-column flex-md-row">
      <div class="col-12 col-md-12 p-0">
        <!-- <div class="flex justify-content-end pr-3 pt-3">
          <p-button
            styleClass="border-circle w-2rem h-2rem bg-gray-700 border-gray-700"
            icon="pi pi-times"
            (onClick)="popupTimeoutLogin = false"
          />
        </div> -->
        <div class="flex flex-column w-full gap-3">
          <span class="text-xl">
            You've been inactive for a while. For your security, you’ll be
            signed out in 2 minutes. <br />
            Click “Confirm” to remain signed in.
          </span>
          <p-button
            label="Confirm"
            [rounded]="true"
            [style]="{ width: 'fit-content', 'font-size': '15px' }"
            (click)="reNewSession()"
            styleClass="border-round border-2 transition-colors hover:surface-900 hover:border-900 checkout-button mb-1"
          ></p-button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
